import { Routes, Route } from "react-router-dom";
import AdminSidebar from "@/pages/admin/components/AdminSidebar";
import LinkMonitorBootstrap from "@/pages/admin/components/LinkMonitorBootstrap";
import AdminDashboard from "@/pages/admin/dashboard/page";
import AdminProducts from "@/pages/admin/products/page";
import AdminArticles from "@/pages/admin/articles/page";
import AdminDeals from "@/pages/admin/deals/page";
import AdminHighlights from "@/pages/admin/highlights/page";
import AdminLinks from "@/pages/admin/links/page";
import AdminSettings from "@/pages/admin/settings/page";
import AdminCategories from "@/pages/admin/categories/page";
import AdminReports from "@/pages/admin/reports/page";
import AdminHero from "@/pages/admin/hero/page";
import AdminMarketplaces from "@/pages/admin/marketplaces/page";
import AdminGuard from "@/pages/admin/auth/AdminGuard";

export default function AdminPage() {
  return (
    <AdminGuard>
      <div className="flex min-h-screen bg-gray-50">
        <LinkMonitorBootstrap />
        <AdminSidebar />
        <main className="flex-1 px-8 py-8 overflow-auto">
          <Routes>
            <Route index element={<AdminDashboard />} />
            <Route path="hero" element={<AdminHero />} />
            <Route path="marketplaces" element={<AdminMarketplaces />} />
            <Route path="produtos" element={<AdminProducts />} />
            <Route path="artigos" element={<AdminArticles />} />
            <Route path="ofertas" element={<AdminDeals />} />
            <Route path="destaques" element={<AdminHighlights />} />
            <Route path="links" element={<AdminLinks />} />
            <Route path="categorias" element={<AdminCategories />} />
            <Route path="configuracoes" element={<AdminSettings />} />
            <Route path="relatorios" element={<AdminReports />} />
          </Routes>
        </main>
      </div>
    </AdminGuard>
  );
}